module.exports = __webpack_public_path__ + "static/media/folder-open.e647cb24.svg";